const JWT = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="9" fill="black" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.312 11.9591V7.25342H14.688V11.9591L16 13.7609L17.312 11.9591Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.688 20.0409V24.7466H17.312V20.0409L16 18.2391L14.688 20.0409Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.312 20.0409L20.0759 23.8544L22.2101 22.2975L19.4287 18.5015L17.312 17.8018V20.0409Z"
      fill="#3EC6EB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.688 11.9591L11.9241 8.14563L9.78992 9.70252L12.5713 13.4985L14.688 14.1983V11.9591Z"
      fill="#3EC6EB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5713 13.4984L8.09305 12.0465L7.27087 14.548L11.7491 16L13.8833 15.3177L12.5713 13.4984Z"
      fill="#FF44DD"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.1167 16.6822L19.4287 18.5015L23.9069 19.9535L24.7291 17.4519L20.2509 16L18.1167 16.6822Z"
      fill="#FF44DD"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.2509 16L24.7291 14.548L23.9069 12.0465L19.4287 13.4984L18.1167 15.3177L20.2509 16Z"
      fill="#635DFF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7491 16L7.27087 17.4519L8.09305 19.9535L12.5713 18.5015L13.8833 16.6822L11.7491 16Z"
      fill="#635DFF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5713 18.5015L9.78992 22.2975L11.9241 23.8544L14.688 20.0409V17.8018L12.5713 18.5015Z"
      fill="#FF4F40"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.4287 13.4985L22.2101 9.70252L20.0759 8.14563L17.312 11.9591V14.1983L19.4287 13.4985Z"
      fill="#FF4F40"
    />
  </svg>
);

export default JWT;
